import React, { useState } from 'react'
import { MenuOutlined } from '@ant-design/icons'
import { Button, Modal, Table, Checkbox } from 'antd'
import { arrayMoveImmutable } from 'array-move'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'

import './index.css'

const DragHandle = SortableHandle(() => (
  <MenuOutlined
    style={{
      cursor: 'grab',
      color: '#999',
    }}
  />
))
const SortableItem = SortableElement((props) => <tr {...props} />)
const SortableBody = SortableContainer((props) => <tbody {...props} />)

const ColumnsSettings = ({ data, showModal, onChancel, onSave }) => {
  const [dataSource, setDataSource] = useState(data)

  const onCheckChange = (record) => (e) => {
    const newData = [...dataSource]
    const index = newData.findIndex((item) => item.key === record.key)
    if (index > -1) {
      newData[index].display = e.target.checked
    }
    setDataSource(newData)
  }

  const columns = [
    {
      title: 'Порядок',
      dataIndex: 'sort',
      className: 'drag-visible',
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: 'Название поля',
      dataIndex: 'name',
      className: 'drag-visible',
    },
    {
      title: 'Отобразить / скрыть',
      dataIndex: 'display',
      className: 'drag-visible',
      align: 'center',
      render: (display, record) => {
        return <Checkbox checked={record.display} onChange={onCheckChange(record)} />
      },
    },
  ]

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMoveImmutable(dataSource.slice(), oldIndex, newIndex).filter((el) => !!el)
      setDataSource(newData)
    }
  }

  const DraggableContainer = (props) => (
    <SortableBody useDragHandle disableAutoscroll helperClass="row-dragging" onSortEnd={onSortEnd} {...props} />
  )

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // function findIndex base on Table rowKey props and should always be a right array index
    const index = dataSource.findIndex((x) => x.index === restProps['data-row-key'])
    return <SortableItem index={index} {...restProps} />
  }

  const onCancelHandler = () => {
    onChancel()
  }

  const onSaveHandler = () => {
    onSave(dataSource)
    onChancel()
  }

  return (
    <Modal
      title="Настройка полей для отображения в таблице заявок"
      visible={showModal}
      onCancel={onCancelHandler}
      footer={[
        <Button key="back" onClick={onCancelHandler}>
          Отмена
        </Button>,
        <Button type="primary" key="save" onClick={onSaveHandler}>
          Сохранить
        </Button>,
      ]}
    >
      <Table
        pagination={false}
        dataSource={dataSource}
        columns={columns}
        rowKey="index"
        scroll={{ y: 240 }}
        size="small"
        components={{
          body: {
            wrapper: DraggableContainer,
            row: DraggableBodyRow,
          },
        }}
      />
    </Modal>
  )
}

export default ColumnsSettings
